import { render, staticRenderFns } from "./SuggestOverview.vue?vue&type=template&id=acc515ae&"
import script from "./SuggestOverview.vue?vue&type=script&lang=js&"
export * from "./SuggestOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports